import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { GameProfile, Menu, ProfileCtx } from "./types";

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic_server_settings" } },
  { component: "ConfSection", props: { name: "advanced_server_settings" } },
  { component: "ConfSection", props: { name: "survival" } },
  { component: "ConfSection", props: { name: "vehicles" } },
  { component: "ConfSection", props: { name: "npcs" } },
  { component: "ConfSection", props: { name: "combat" } },
  { component: "ConfSection", props: { name: "resources" } },
  { component: "ConfSection", props: { name: "structures" } },
];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
});
